export function isAbortError(error: unknown): boolean {
    return Boolean(error && typeof error === 'object' && 'name' in error && error.name === 'AbortError');
}

export function playMediaElement(
    mediaElement: HTMLMediaElement | null | undefined,
    onError?: (error: unknown) => void
) {
    try {
        const playPromise = mediaElement?.play();

        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch((error: unknown) => {
                if (!isAbortError(error)) {
                    onError?.(error);
                }
            });
        }
    } catch (error) {
        if (!isAbortError(error)) {
            onError?.(error);
        }
    }
}
